<div class="mb-3">
  <span class="me-3 font-regular">{{ 'tkey;admin.sitemacman.modal.userId.label' | translate }}</span>
  <span>{{ modalViewProperties.permission.userId }}</span>
</div>
<ziro-radio [fieldId]="'accessLevel'"></ziro-radio>
<ziro-filter-input
  (filterChanged)="onChanged($event)"
  [value]="resultFilter"
  [dataAutomation]="'site-based-helpdesk-filter'"
></ziro-filter-input>
@if (authorization === 'SITES') {
  <div class="custom-table">
    @for (item of filteredAuthorizedSitesOpts; track item; let i = $index) {
      <div>
        @if (isClusterNameDisplayed(i, item.cluster)) {
          <div class="col-12 text-muted custom-table__header">
            {{ item.cluster }}
          </div>
        }
        <div class="col-12 form-check custom-table__row">
          <input
            type="checkbox"
            name="'{{ item.cluster }}'"
            class="form-check-input"
            id="select-site-{{ item.site }}"
            [checked]="selectedSites.indexOf(item.site) > -1"
            (change)="updateSiteSelection(item.site, $event)"
          />
          <label for="select-site-{{ item.site }}" class="form-check-label">
            {{ item.site }}
          </label>
        </div>
      </div>
    }
  </div>
}
@if (authorization === 'CLUSTERS') {
  <div class="custom-table">
    @for (item of filteredAuthorizedClusterOpts; track item) {
      <div class="d-flex">
        <div class="col-12 form-check custom-table__row">
          <input
            type="checkbox"
            class="form-check-input"
            id="select-cluster-{{ item.name }}"
            [checked]="selectedClusters.indexOf(item.name) > -1"
            (change)="updateClusterSelection(item.name, $event)"
          />
          <label for="select-cluster-{{ item.name }}" class="form-check-label">{{ item.name }}</label>
        </div>
      </div>
    }
  </div>
}
<div class="checkbox-container">
  <ziro-checkbox [fieldId]="'readAccessToReportingEnabled'"></ziro-checkbox>
  <ziro-checkbox [fieldId]="'isAccessDisabled'"></ziro-checkbox>
</div>
